import { TranslatableText } from '@dreryk/react-common';
import {
   Notification,
   NotificationSize,
   NotificationType,
   TestableComponentProps,
   TextEditor,
} from '@dreryk/react-components';

import { StyledVisitHistoryText } from './VisitHistoryText.styled';

type VisitHistoryTextProps = TestableComponentProps & {
   readonly noContent: TranslatableText;
   readonly content: string | undefined;
};

export const VisitHistoryText = (props: VisitHistoryTextProps): JSX.Element => {
   if (!props.content) {
      return (
         <Notification
            testId={props.testId}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
            label={props.noContent}
         />
      );
   }

   return (
      <StyledVisitHistoryText testId={props.testId}>
         <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
               __html: TextEditor.sanitize(props.content.trim()),
            }}
         />
      </StyledVisitHistoryText>
   );
};
